import {
  useCreateServiceFacilityMutation,
  useDeleteServiceFacilityMutation,
  useGetServiceFacilitiesQuery,
  useGetServiceFacilityQuery,
  useSetDefaultServiceFacilityMutation,
  useUpdateServiceFacilityMutation,
} from './api';

/**
 * Hook to get service facilities for the current provider's organization
 */
export function useServiceFacilities(options?: { skip?: boolean }) {
  const result = useGetServiceFacilitiesQuery(undefined, {
    skip: options?.skip,
  });

  return {
    facilities: result.data?.service_facilities || [],
    isLoading: result.isLoading,
    isError: result.isError,
    isFetching: result.isFetching,
    error: result.error,
    refetch: result.refetch,
  };
}

/**
 * Hook to get a single service facility
 */
export function useServiceFacility(
  serviceFacilityId: string | null,
  options?: { skip?: boolean },
) {
  const result = useGetServiceFacilityQuery(
    { serviceFacilityId: serviceFacilityId as string },
    {
      skip: !serviceFacilityId || options?.skip,
    },
  );

  return {
    facility: result.data || null,
    isLoading: result.isLoading,
    isError: result.isError,
    isFetching: result.isFetching,
    error: result.error,
    refetch: result.refetch,
  };
}

/**
 * Hook for service facility CRUD operations
 */
export function useServiceFacilityOperations() {
  const [create, createResult] = useCreateServiceFacilityMutation();
  const [update, updateResult] = useUpdateServiceFacilityMutation();
  const [remove, removeResult] = useDeleteServiceFacilityMutation();
  const [setDefault, setDefaultResult] = useSetDefaultServiceFacilityMutation();

  return {
    create,
    createLoading: createResult.isLoading,
    createError: createResult.error,
    createSuccess: createResult.isSuccess,

    update,
    updateLoading: updateResult.isLoading,
    updateError: updateResult.error,
    updateSuccess: updateResult.isSuccess,

    remove,
    removeLoading: removeResult.isLoading,
    removeError: removeResult.error,
    removeSuccess: removeResult.isSuccess,

    setDefault,
    setDefaultLoading: setDefaultResult.isLoading,
    setDefaultError: setDefaultResult.error,
    setDefaultSuccess: setDefaultResult.isSuccess,
  };
}
